var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2127 7.21259L8.39156 10.0338C8.28771 10.1379 8.14683 10.1964 7.99972 10.1964C7.85257 10.1964 7.71158 10.1379 7.60788 10.0339L4.78656 7.21269C4.67833 7.10445 4.62414 6.96231 4.62414 6.82037C4.62414 6.67848 4.67832 6.53653 4.78658 6.42827C5.00319 6.21157 5.35433 6.21157 5.57094 6.42827L7.46838 8.32666V2.68745C7.46838 2.38133 7.71643 2.1333 8.02276 2.1333C8.32906 2.1333 8.57703 2.3813 8.57703 2.68745V8.28036L10.429 6.42823C10.6454 6.21156 10.9967 6.21174 11.2128 6.42831C11.4293 6.64476 11.4294 6.99583 11.2127 7.21259ZM3.24207 9.98884V12.758H12.7575V9.98884C12.7575 9.68256 13.0055 9.43457 13.3118 9.43457C13.618 9.43457 13.866 9.68256 13.866 9.98884V12.7143C13.8661 13.3496 13.3491 13.8666 12.7138 13.8666H3.28552C2.65015 13.8666 2.13281 13.3496 2.13281 12.7143V9.98884C2.13281 9.68268 2.38128 9.43457 2.68744 9.43457C2.9935 9.43457 3.24207 9.68269 3.24207 9.98884Z",
    fill: "#3A4ADE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSmall);
export default __webpack_public_path__ + "static/media/downloadSmall.727df35a92f3f7a9dd34000ca7278f76.svg";
export { ForwardRef as ReactComponent };